import { LookupService } from '../services/lookup.service';
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { FormBuilder, FormGroup, FormArray, FormControl, ValidationErrors } from "@angular/forms";
import { ServiceLocator } from '../services/locator.service';
import { ViewModelService } from '../services/view-model.service';
import { BaseFormViewModel } from '../../ui-ndms/view-models/base-form.view-model';
import { FormObjects } from '../utilities/formObjects';
import { NdmsUtils } from '../utilities/ndmsUtils';
import { Subscription } from "rxjs";
import { NdmsSafeSubscriber } from './ndms-safe-subscriber';

export abstract class HasFormComponent<T extends BaseFormViewModel> extends NdmsSafeSubscriber {
  form: FormGroup;
  formArrayDefaultObjectRegistry: any;
  isEditing: boolean;
  caller: string;
  subscription: Subscription;
  constructor(public lookupService: LookupService,
              public viewModelService: ViewModelService,
              private baseViewModelType: { new(): T },
              autoBuildForm: boolean = true,
              autoSubscribe: boolean = true) {
    super();
    if (autoBuildForm) {
      this.buildForm();

      if (autoSubscribe) {
        this.subscribeVieWModelService()
      }
    }
    else {
      this.form = new FormGroup({
        test: FormObjects.String()
      })
    }
  }

  touchAllFields() {
    NdmsUtils.touchAllFields(this.form);
  }
  bounceAllFields() {
    NdmsUtils.touchAllFields(this.form);
    this.form.markAsUntouched();

  }
  errors(): ValidationErrors {
    return this.form.errors || [];
  }
  isFormValid() {
    if (!this.form.valid) {
      console.log("my form ", this.form.value);
      this.touchAllFields();
      return false;
    }
    return true;
  }

  private buildForm(): void {
    this.form = new this.baseViewModelType().toFormGroup!();
  }

  private subscribeVieWModelService(): void {
    if (this.viewModelService.viewModelUpdated[this.baseViewModelType.name]) {
      this.subscription = this.viewModelService.viewModelUpdated[this.baseViewModelType.name].subscribe((value: T) => {
        if(value){
          this.form = value.toFormGroup!(this.form);
          this.form.patchValue(value);
          this.bounceAllFields();
        }
      });
    }
  }
  ngOnDestroy(){
    if(this.subscription)
      this.subscription.unsubscribe();
  }
}
